// 保存到本地的登录信息
const TokenKey = "token";
export function getToken() {
  return localStorage.getItem(TokenKey);
}

export function setToken(token) {
  return localStorage.setItem(TokenKey, token);
}

export function removeToken() {
  return localStorage.removeItem(TokenKey);
}

// 保存点击登录时的时间戳
const dateTime = "date";
export function getdateTime() {
  return localStorage.getItem(dateTime);
}

export function setdateTime(date) {
  return localStorage.setItem(dateTime, date);
}

export function removedateTime() {
  return localStorage.removeItem(dateTime);
}

/** 设置登录用户Token有效期限 默认为当前时间后30分钟 在登录成功时、有路由跳转时使用 */
export function setTokenExpiry(value = new Date().valueof() + 1800000) {
  return localStorage.setItem("Token-Expiry", value);
}
/** 获取登录用户Token有效期限 */
export function getTokenExpiry() {
  return localStorage.getItem("Token-Expiry");
}
/** 移除登录用户Token有效期限 在用户退出登录时使用 */
export function removeTokenExpiry() {
  return localStorage.removeItem("Token-Expiry");
}

// 保存个人信息
const UserInfo = "userfin";

export function getUserInfo() {
  return JSON.parse(localStorage.getItem(UserInfo));
}

export function setUserInfo(token) {
  return localStorage.setItem(UserInfo, JSON.stringify(token));
}

export function removeUserInfo() {
  return localStorage.removeItem(UserInfo);
}
